import { render, staticRenderFns } from "./VerificationModal.vue?vue&type=template&id=75fb1b00&scoped=true&"
import script from "./VerificationModal.vue?vue&type=script&lang=js&"
export * from "./VerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./VerificationModal.vue?vue&type=style&index=0&id=75fb1b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fb1b00",
  null
  
)

export default component.exports